import auth, { AuthParams } from '@/utils/authentication';
import { useEffect, useMemo, useState } from 'react';
export type IRoute = AuthParams & {
  name: string;
  key: string;
  // 当前页是否展示面包屑
  breadcrumb?: boolean;
  children?: IRoute[];
  // 当前路由是否渲染菜单项，为 true 的话不会在菜单中显示，但可通过路由地址访问。
  ignore?: boolean;
  buttons?: {
    name: string;
    title: string;
  }[];
};

export const routes: IRoute[] = [
  {
    name: '首页',
    key: 'dashboard',
    requiredPermissions: [],
  },
  {
    name: '用户管理',
    key: 'member',
    requiredPermissions: [],
    oneOfPerm: true,
    children: [
      {
        name: '用户信息',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'member/index',
        buttons: [
          {
            name: '用户列表',
            title: 'member/index',
          },
          {
            name: '启用/禁用',
            title: 'member:updateStatus',
          },
        ],
      },
      {
        name: '用户详情',
        requiredPermissions: [],
        oneOfPerm: false,
        ignore: true,
        key: 'member/detail',
        buttons: [
          {
            name: '用户详情',
            title: 'member/detail',
          },
          {
            name: '添加订单',
            title: 'member:addOrder',
          },
          {
            name: '保存',
            title: 'member:update',
          },
          {
            name: '查看优惠券',
            title: 'member:coupon:view',
          },
        ],
      },
    ],
  },
  {
    name: '销售管理',
    key: 'sales',
    requiredPermissions: [],
    oneOfPerm: true,
    children: [
      {
        name: '销售订单',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'sales/order/index',
        buttons: [
          {
            name: '销售订单列表',
            title: 'sales/order/index',
          },
          {
            name: '订单售后',
            title: 'order:refundOrder:create',
          },
        ],
      },
      {
        name: '添加手工单',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'sales/order/update',
        ignore: true,
      },
      {
        name: '销售订单详情',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'sales/order/detail',
        ignore: true,
      },
      {
        name: '验光单',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'sales/optometryOrder/index',
        buttons: [
          {
            name: '验光单列表',
            title: 'sales/optometryOrder/index',
          },
          {
            name: '添加验光单',
            title: 'optometryOrder:create',
          },
        ],
      },
      {
        name: '验光单详情',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'sales/optometryOrder/detail',
        ignore: true,
      },
      {
        name: '排号管理',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'lineUp/index',
        buttons: [
          {
            name: '排号管理列表',
            title: 'lineUp/index',
          },
          {
            name: '取消排队',
            title: 'lineUp:cancel',
          },
        ],
      },
      {
        name: '售后管理',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'sales/refundOrder/index',
      },
      {
        name: '售后订单详情',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'sales/refundOrder/detail',
        ignore: true,
      },
    ],
  },
  {
    name: '门店管理',
    key: 'stores',
    requiredPermissions: [],
    oneOfPerm: true,
    children: [
      {
        name: '店铺信息',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'stores/index',
        buttons: [
          {
            name: '店铺列表',
            title: 'stores/index',
          },
          {
            name: '启用/禁用',
            title: 'store:updateStatus',
          },
        ],
      },
      {
        name: '店铺编辑',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'stores/update',
        ignore: true,
        buttons: [
          {
            name: '店铺详情查看/编辑页',
            title: 'stores/update',
          },
          {
            name: '新增/编辑',
            title: 'store:update',
          },
        ],
      },
      {
        name: '验光师信息',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'optometrist/index',
        buttons: [
          {
            name: '验光师列表',
            title: 'optometrist/index',
          },
          {
            name: '启用/禁用',
            title: 'optometrist:updateStatus',
          },
        ],
      },
      {
        name: '验光师编辑',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'optometrist/update',
        ignore: true,
        buttons: [
          {
            name: '验光师详情查看',
            title: 'optometrist/update',
          },
          {
            name: '新增/编辑',
            title: 'optometrist:update',
          },
        ],
      },
    ],
  },
  {
    name: '库存管理',
    key: 'stocks',
    requiredPermissions: [],
    oneOfPerm: true,
    children: [
      {
        name: '镜架库存',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'stocks/spectaclesFrame/index',
        buttons: [
          {
            name: '镜架库存列表',
            title: 'stocks/spectaclesFrame/index',
          },
          {
            name: '镜架品牌管理',
            title: 'spectaclesFrame:brand',
          },
          {
            name: '启用/禁用',
            title: 'spectaclesFrame:updateStatus',
          },
        ],
      },
      {
        name: '镜架型号管理',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'stocks/spectaclesFrameModel/index',
        ignore: true,
      },
      {
        name: '镜架入库',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'stocks/spectaclesFrameOperation/store/index',
        ignore: true,
      },
      {
        name: '镜架出库',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'stocks/spectaclesFrameOperation/outbound/index',
        ignore: true,
      },
      {
        name: '镜架报废',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'stocks/spectaclesFrameOperation/abandon/index',
        ignore: true,
      },
      {
        name: '镜架退货',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'stocks/spectaclesFrameOperation/rollback/index',
        ignore: true,
      },
      {
        name: '镜架出入库记录',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'stocks/spectaclesFrameStoreOrder/index',
        ignore: true,
      },
      {
        name: '镜片库存',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'stocks/lens/index',
        buttons: [
          {
            name: '镜片库存列表',
            title: 'stocks/lens/index',
          },
          {
            name: '镜片品牌管理',
            title: 'lens:brand',
          },
          {
            name: '镜片品牌管理',
            title: 'lens:updateStatus',
          },
        ],
      },
      {
        name: '镜片系列管理',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'stocks/lensSeries/index',
        ignore: true,
      },
      {
        name: '镜片入库',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'stocks/lensOperation/store/index',
        ignore: true,
      },
      {
        name: '镜片出库',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'stocks/lensOperation/outbound/index',
        ignore: true,
      },
      {
        name: '镜片报废',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'stocks/lensOperation/abandon/index',
        ignore: true,
      },
      {
        name: '镜片退货',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'stocks/lensOperation/rollback/index',
        ignore: true,
      },
      {
        name: '镜片库存生成',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'stocks/lensOperation/generate/index',
        ignore: true,
      },
      {
        name: '镜片出入库记录',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'stocks/lensStoreOrder/index',
        ignore: true,
      },
      {
        name: '镜片库存详情',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'stocks/lens/detail',
        ignore: true,
      },
      {
        name: '供应商管理',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'stocks/supplier/index',
        buttons: [
          {
            name: '供应商列表',
            title: 'stocks/supplier/index',
          },
          {
            name: '添加供应商',
            title: 'supplier:create',
          },
          {
            name: '编辑供应商',
            title: 'supplier:update',
          },
          {
            name: '启用/禁用',
            title: 'supplier:updateStatus',
          },
        ],
      },
      {
        name: '材质管理',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'stocks/material/index',
        buttons: [
          {
            name: '材质管理列表',
            title: 'stocks/material/index',
          },
          {
            name: '添加',
            title: 'material:create',
          },
          {
            name: '编辑',
            title: 'material:update',
          },
          {
            name: '启用/禁用',
            title: 'material:updateStatus',
          },
        ],
      },
      {
        name: '盘点管理',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'stocks/stocktaking',
      },
      {
        name: '添加盘点',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'stocks/stockTakingOperation/index',
        ignore: true,
      },
    ],
  },
  {
    name: '营销管理',
    key: 'markets',
    requiredPermissions: [],
    oneOfPerm: true,
    children: [
      {
        name: '优惠券',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'markets/coupon/index',
        buttons: [
          {
            name: '优惠券列表',
            title: 'markets/coupon/index',
          },
          {
            name: '暂停发放',
            title: 'markets:coupon:updateStatus',
          },
        ],
      },
      {
        name: '新增优惠券',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'markets/coupon/update',
        ignore: true,
      },
      {
        name: '优惠券查看',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'markets/coupon/detail',
        ignore: true,
      },
    ],
  },
  {
    name: '财务管理',
    key: 'finance',
    requiredPermissions: [],
    oneOfPerm: true,
    children: [
      {
        name: '订单核算',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'finance/accounting/index',
      },
      {
        name: '订单核算详情',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'finance/accounting/detail',
        ignore: true,
      },
      {
        name: '财务统计',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'finance/charts/index',
      },
    ],
  },
  {
    name: '系统管理',
    key: 'setting',
    requiredPermissions: [],
    oneOfPerm: true,
    children: [
      {
        name: '员工管理',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'user/staff/index',
        buttons: [
          {
            name: '员工列表',
            title: 'user/staff/index',
          },
          {
            name: '新增/编辑',
            title: 'staff:update',
          },
          {
            name: '启用/禁用',
            title: 'staff:updateStatus',
          },
        ],
      },
      {
        name: '员工编辑',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'user/staff/update',
        ignore: true,
      },
      {
        name: '角色管理',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'role/index',
        buttons: [
          {
            name: '角色管理列表',
            title: 'role/index',
          },
          {
            name: '添加',
            title: 'role:create',
          },
          {
            name: '编辑',
            title: 'role:update',
          },
          {
            name: '删除',
            title: 'role:delete',
          },
        ],
      },
      {
        name: '后台设置',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'setting/setting/index',
      },
      {
        name: '小票机管理',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'setting/ticketMachine/index',
        buttons: [
          {
            name: '小票机管理列表',
            title: 'setting/ticketMachine/index',
          },
          {
            name: '新增/编辑',
            title: 'ticketMachine:update',
          },
          {
            name: '启用/禁用',
            title: 'ticketMachine:updateStatus',
          },
        ],
      },
      {
        name: '小票机编辑',
        requiredPermissions: [],
        oneOfPerm: false,
        key: 'setting/ticketMachine/update',
        ignore: true,
      },
    ],
  },
  {
    name: '打印镜片出入库单',
    requiredPermissions: [],
    oneOfPerm: false,
    key: 'print/lens',
    ignore: true,
  },
  {
    name: '打印镜架出入库单',
    requiredPermissions: [],
    oneOfPerm: false,
    key: 'print/frame',
    ignore: true,
  },
  {
    name: '打印盘点清单',
    requiredPermissions: [],
    oneOfPerm: false,
    key: 'print/stocktaking',
    ignore: true,
  },
  {
    name: '打印销售订单',
    requiredPermissions: [],
    oneOfPerm: false,
    key: 'print/order',
    ignore: true,
  },
  {
    name: '打印售后单',
    requiredPermissions: [],
    oneOfPerm: false,
    key: 'print/refundOrder',
    ignore: true,
  },
];

export const getName = (path: string, routes) => {
  return routes.find((item) => {
    const itemPath = `/${item.key}`;
    if (path === itemPath) {
      return item.name;
    } else if (item.children) {
      return getName(path, item.children);
    }
  });
};

const useRoute = (userPermission): [IRoute[], string] => {
  const filterRoute = (routes: IRoute[], arr = []): IRoute[] => {
    if (!routes.length) {
      return [];
    }
    for (const route of routes) {
      let { requiredPermissions, oneOfPerm } = route;
      if ((route.children || []).length > 0) {
        requiredPermissions = route.children
          .filter((i) => !i.ignore)
          .map((item) => item.key);
        oneOfPerm = true;
      } else {
        requiredPermissions = [route.key];
        oneOfPerm = false;
      }
      // console.warn(requiredPermissions, 'requiredPermissions', oneOfPerm);

      let visible = true;
      if (requiredPermissions) {
        visible = auth({ requiredPermissions, oneOfPerm }, userPermission);
      }

      if (!visible) {
        continue;
      }
      if (route.children && route.children.length) {
        const newRoute = { ...route, children: [] };
        filterRoute(route.children, newRoute.children);
        if (newRoute.children.length) {
          arr.push(newRoute);
        }
      } else {
        arr.push({ ...route });
      }
    }

    return arr;
  };

  const [permissionRoute, setPermissionRoute] = useState(routes);

  useEffect(() => {
    const newRoutes = filterRoute(routes);
    setPermissionRoute(newRoutes);
  }, [JSON.stringify(userPermission)]);

  const defaultRoute = useMemo(() => {
    const first = permissionRoute[0];
    if (first) {
      const firstRoute = first?.children?.[0]?.key || first.key;
      return firstRoute;
    }
    return '';
  }, [permissionRoute]);

  return [permissionRoute, defaultRoute];
};

export default useRoute;
